export default "__VITE_ASSET__e4dc9c65__"